<template>
  <v-flex sm12>
    <v-container fluid pt-5 pb-5 mt-5>
      <v-flex>
        <v-card md12 class="mb-5 elevation-0">
          <v-tabs centered color="#D5D5D5" show-arrows v-model="tab" class="rounded-tabs">
            <v-toolbar-title class="title">
              <div class="display-1 mt-3 mr-5 tamany_titol tw-txt-color-primary">{{ 'settings.title' | t }}</div>
            </v-toolbar-title>
            <v-tabs-slider color="primary ratlla"></v-tabs-slider>
          </v-tabs>

          <v-dialog v-model="dialog_contract" scrollable>
            <v-card>
              <v-card-title>
                <span class="headline primary--text">
                  {{ `settings.dialog_contract.${dialogkey_contract}` | t }}
                </span>
              </v-card-title>
              <v-card-text>
                <span v-html="contract[dialogkey_contract]"></span>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions align-right>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" flat="flat" @click.native="dialog_contract = false">{{ `settings.dialog_contract.close` | t }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog_delete" scrollable>
            <v-card>
              <v-card-title>
                <span class="headline primary--text">{{ `settings.dialog_delete.title` | t }}</span>
              </v-card-title>
              <v-card-text>
                <span>{{ `settings.dialog_delete.message` | t }}</span>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions align-right>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" flat @click.native="dialog_delete = false">{{ `settings.dialog_delete.cancel` | t }}</v-btn>
                <v-btn class="error white--text darken-4" @click.native="deleteAccount">
                  <v-icon>sentiment_very_dissatisfied</v-icon>
                  {{ `settings.dialog_delete.confirm` | t }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-flex md12 class="elevation-0">
            <v-layout row wrap>
              <v-flex md2 d-flex class="">
                <v-layout row wrap>
                  <v-flex md12 mt-3 d-flex class="background tw-txt-color-primary rounded-tabs-sub">
                    <v-card-text>
                      <v-row align-top>
                        <div class="tamany_titol_sitebar">{{ 'settings.sitebar.title' | t }}</div>
                        <br />
                        <p>{{ 'settings.sitebar.description' | t }}</p>
                        <br />
                        <div class="tamany_titol_sitebar">{{ 'settings.sitebar.sub_title_01' | t }}</div>
                        <br />
                        <ul>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_01' | t }}</b> {{ 'settings.sitebar.li_01_text_01' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_02' | t }}</b> {{ 'settings.sitebar.li_01_text_02' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_03' | t }}</b> {{ 'settings.sitebar.li_01_text_03' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_04' | t }}</b> {{ 'settings.sitebar.li_01_text_04' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_05' | t }}</b> {{ 'settings.sitebar.li_01_text_05' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_06' | t }}</b> {{ 'settings.sitebar.li_01_text_06' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_07' | t }}</b> {{ 'settings.sitebar.li_01_text_07' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_08' | t }}</b> {{ 'settings.sitebar.li_01_text_08' | t }}
                          </li>
                          <li>
                            <b> {{ 'settings.sitebar.li_01_title_09' | t }}</b> {{ 'settings.sitebar.li_01_text_09' | t }}
                          </li>
                        </ul>
                      </v-row>
                    </v-card-text>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md10>
                <v-flex md12 class="mt-3">
                  <div class="headline tw-txt-color-primary ml-3 subtitol rounded-tabs-sub">{{ 'settings.title_user' | t }}</div>
                  <v-card-text>
                    <user-form />
                  </v-card-text>
                </v-flex>
                <v-flex md12 class="mt-3">
                  <div class="headline tw-txt-color-primary ml-3 subtitol rounded-tabs-sub">{{ 'settings.terms_title' | t }}</div>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-btn flat color="indigo darken-4" @click="readTerms('terms')"> <v-icon>gavel</v-icon> {{ 'settings.terms_text' | t }} </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-btn flat color="indigo darken-4" @click="readTerms('privacy')"> <v-icon>lock</v-icon> {{ 'settings.privacy_text' | t }} </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
                <v-flex md12 class="mt-3">
                  <v-card class="elevation-0 mt-3">
                    <div class="headline tw-txt-color-primary ml-3 subtitol rounded-tabs-sub">{{ 'settings.delete_account_title' | t }}</div>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex md12 offset-md1>
                          <v-btn color="error white--text darken-4" @click="dialog_delete = true">{{ 'settings.delete_account' | t }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
      <faqs></faqs>
    </v-container>
  </v-flex>
</template>

<script>
import UserForm from '@/components/UserForm'
import { mapGetters, mapActions } from 'vuex'
import Faqs from '@/components/Faqs'

export default {
  components: {
    UserForm,
    Faqs
  },
  computed: {
    ...mapGetters(['getServer', 'getUserId', 'getTokenHeader'])
  },
  data: () => ({
    contract: {
      terms: 'TERMS TEXT',
      privacy: 'PRIVACY TEXT'
    },
    dialogkey: 'confirm',
    dialog_contract: false,
    dialogkey_contract: 'terms',
    dialog_delete: false
  }),
  created() {
    //const server = 'https://dashboard.trawlingweb.com/api'
    const server = this.getServer
    this.$http
      .get(`${server}/users/${this.getUserId}/terms`, this.getTokenHeader)
      .then(res => {
        this.contract = res.data
      })
      .catch(() => {
        alert('PROBLEMS LOADING DATA')
      })
  },
  methods: {
    ...mapActions(['rmKey', 'getSession']),
    readTerms(key) {
      this.dialogkey_contract = key
      this.dialog_contract = true
    },
    deleteAccount() {
      //const server = 'https://dashboard.trawlingweb.com/api'
      const server = this.getServer
      this.$http.get(`${server}/users/${this.getUserId}/stop`, this.getTokenHeader).then(() => {
        this.rmKey()
      })
    }
  }
}
</script>
<style scoped>
.rounded-tabs {
  border-radius: 6px !important;
}
.rounded-tabs-sub {
  border-radius: 6px !important;
}
.tamany_titol {
  font-size: 28px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.tamany_titol_sitebar {
  font-size: 18px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
.ratlla {
  height: 3px !important;
}
.subtitol {
  padding-top: 8px !important;
  padding-left: 20px !important;
  background-color: #f2f2f2 !important;
  padding-bottom: 6px !important;
}
.nobot {
  padding-bottom: 0px !important;
}
.background {
  /*background-color: rgb(241 85 80 / 15%) !important;*/
  background: linear-gradient(to bottom, rgb(241 85 80 / 15%), #ffffff) !important; /* De rojo a blanco */
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
